import React from 'react';
import Billing from '../sections/Billing';

export const ChangePayment: React.FunctionComponent = () => {
  return (
    <>
      <Billing />
    </>
  );
};

export default ChangePayment;
